// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--2mljH","amenities":"a10a3f92e9--amenities--2QaDf","amenities-group":"a10a3f92e9--amenities-group--3a2OG"};